export const setWorkspaceDomain = (value: any) => {
	return {
		type: 'SET_WORKSPACE_DOMAIN',
		payload: value,
	};
};

export const clearWorkspaceDomain = () => {
	return {
		type: 'CLEAR_WORKSPACE_DOMAIN',
	};
};
